<script setup lang="ts">
import { DropdownMenuTrigger, useForwardProps } from "reka-ui";

const props = defineProps({});

const forwardedProps = useForwardProps(props);
</script>

<template>
  <DropdownMenuTrigger class="vf-outline-none" v-bind="forwardedProps">
    <slot />
  </DropdownMenuTrigger>
</template>
